import { render, staticRenderFns } from "./chemicalIntoRecord.vue?vue&type=template&id=52d4a270&scoped=true"
import script from "./chemicalIntoRecord.vue?vue&type=script&lang=js"
export * from "./chemicalIntoRecord.vue?vue&type=script&lang=js"
import style0 from "./chemicalIntoRecord.vue?vue&type=style&index=0&id=52d4a270&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d4a270",
  null
  
)

export default component.exports